import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { formatApiError } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(undefined); // undefined = checking, null = signed out, object = signed in
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const login = async (email, password) => {
        try {
            const { data } = await api.post("/auth/login", { email, password });
            if (data?.token) localStorage.setItem("derm_token", data.token);
            setUser(data.user);
            return { ok: true, user: data.user };
        } catch (err) {
            return { ok: false, error: formatApiError(err) };
        }
    };

    const logout = async () => {
        try { await api.post("/auth/logout"); } catch { /* ignore */ }
        localStorage.removeItem("derm_token");
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, logout, refresh, setUser }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
